import { checkHttpStatusAuthCheck } from '../../../../../actions/utilAction';
import {
    actionCreator,
    checkHttpStatus,
    jsonApiHeader,
    SuperadminReportsActionTypes,
    GET_MASTERDATABYNAME,
  } from '../constants/ApiConstants';
  

export const getMasterData = (masterData) => {
    return (dispatch, getState) => {
      dispatch(actionCreator(SuperadminReportsActionTypes.get_master_data.REQUEST));
      fetch(`${GET_MASTERDATABYNAME}`, {
        method: 'post',
        body: JSON.stringify(masterData),
        headers: jsonApiHeader(getState().login.access_token, 'application/json'),
      })
        .then((res)=>checkHttpStatusAuthCheck(res,dispatch,getState))
        .then(function(response) {
          //  console.log('Master Data response: ', response);
          dispatch(actionCreator(SuperadminReportsActionTypes.get_master_data.SUCCESS, response));
        })
        .catch(function(error) {
          console.log('error getMasterData ..', error);
        });
    };
  };


// WEBPACK FOOTER //
// ./src/modules/Superadmin/components/Reports/actions/index.js